export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-secondary-500/10 rounded-3xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-4">
              随时随地 · 畅享精彩
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-[480px] mx-auto lg:mx-0">
              桔子视频全面适配手机、平板、电脑等各类设备，无需下载安装任何APP，
              打开浏览器即可畅享全网热门视频内容。红桃视频、樱桃视频、茄子视频、糖心视频
              一站聚合，走到哪看到哪，精彩不间断。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 border border-background-200/70">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-smartphone-line text-xl text-primary-500"></i>
                </div>
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  手机端直接访问
                </span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 border border-background-200/70">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-computer-line text-xl text-accent-500"></i>
                </div>
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  电脑端大屏观看
                </span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[380px] lg:max-w-none">
            <div className="relative">
              <div className="aspect-[3/4] max-w-[240px] mx-auto rounded-[2rem] overflow-hidden border-[6px] border-foreground-900/10 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20mobile%20phone%20screen%20mockup%20showing%20a%20video%20streaming%20platform%20interface%20with%20multiple%20video%20thumbnail%20cards%20in%20a%20vertical%20list%2C%20warm%20orange%20and%20dark%20theme%2C%20clean%20modern%20UI%20design%2C%20entertainment%20app%20aesthetic%2C%20soft%20lighting&width=600&height=800&seq=app-mockup-2026&orientation=portrait"
                  alt="桔子视频手机端界面"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -top-3 -right-3 w-16 h-16 rounded-2xl bg-accent-500 flex items-center justify-center border-2 border-background-50">
                <span className="text-xs font-bold text-background-50 text-center leading-tight">免安装</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}